import PracticeRecord from "./PracticeRecord";
import UserSegmentAggregate from "./UserSegmentAggregate";
import Badge from "./Badge";
import User from "./User";
/**
 * AddPracticeRecordResponse - what is returned from the api when add practice record is called.
 */
export default class AddPracticeRecordResponse {
  //this appears to be an array of 1 entry, which is the practice record sent as part of the add practice record request.
  practiceRecords: PracticeRecord[];
  userSegmentAggregates: UserSegmentAggregate[];
  badges: Badge[];
  user: User;
  starsAwarded: number;
  timeSessionPointsAwarded: number;
  totalSessionPoints: number;
  performanceSessionPointsAwarded: number;
  constructor({ practiceRecords = [], starsAwarded, timeSessionPointsAwarded, totalSessionPoints, userSegmentAggregates = [], badges = [], user, performanceSessionPointsAwarded, }: AddPracticeRecordResponse) {
    Object.assign(this, { practiceRecords, starsAwarded, timeSessionPointsAwarded, totalSessionPoints, userSegmentAggregates, badges, user, performanceSessionPointsAwarded, });
  }
}